// extracted by mini-css-extract-plugin
module.exports = {"description":"uB1mLZ","shine-lines":"_2ppKce"};